import { GetterTree, MutationTree, Module, ActionTree } from 'vuex'
import { RootState, PaymentMethodsState } from './types'

type PaymentMethodsGetter = GetterTree<PaymentMethodsState, RootState>

export const state: PaymentMethodsState = {
  countryCurrencies: [
    {
      country: 'AT',
      currency: 'EUR'
    },
    {
      country: 'AU',
      currency: 'AUD'
    },
    {
      country: 'BE',
      currency: 'EUR'
    },
    {
      country: 'BR',
      currency: 'BRL'
    },
    {
      country: 'CA',
      currency: 'CAD'
    },
    {
      country: 'CH',
      currency: 'CHF'
    },
    {
      country: 'CO',
      currency: 'COP'
    },
    {
      country: 'CY',
      currency: 'EUR'
    },
    {
      country: 'DE',
      currency: 'EUR'
    },
    {
      country: 'EE',
      currency: 'EUR'
    },
    {
      country: 'ES',
      currency: 'EUR'
    },
    {
      country: 'FI',
      currency: 'EUR'
    },
    {
      country: 'FR',
      currency: 'EUR'
    },
    {
      country: 'GB',
      currency: 'GBP'
    },
    {
      country: 'GR',
      currency: 'EUR'
    },
    {
      country: 'HK',
      currency: 'HKD'
    },
    {
      country: 'IN',
      currency: 'INR'
    },
    {
      country: 'ID',
      currency: 'IDR'
    },
    {
      country: 'IE',
      currency: 'EUR'
    },
    {
      country: 'IL',
      currency: 'ILS'
    },
    {
      country: 'IT',
      currency: 'EUR'
    },
    {
      country: 'KOR',
      currency: 'KRW'
    },
    {
      country: 'LV',
      currency: 'EUR'
    },
    {
      country: 'MT',
      currency: 'EUR'
    },
    {
      country: 'MX',
      currency: 'MXN'
    },
    {
      country: 'MY',
      currency: 'MYR'
    },
    {
      country: 'NG',
      currency: 'NGN'
    },
    {
      country: 'NL',
      currency: 'EUR'
    },
    {
      country: 'NO',
      currency: 'NOK'
    },
    {
      country: 'NZ',
      currency: 'NZD'
    },
    {
      country: 'PE',
      currency: 'PEN'
    },
    {
      country: 'PH',
      currency: 'PHP'
    },
    {
      country: 'PL',
      currency: 'PLN'
    },
    {
      country: 'PT',
      currency: 'EUR'
    },
    {
      country: 'RU',
      currency: 'RUB'
    },
    {
      country: 'SE',
      currency: 'SEK'
    },
    {
      country: 'SK',
      currency: 'EUR'
    },
    {
      country: 'SG',
      currency: 'SGN'
    },
    {
      country: 'SL',
      currency: 'EUR'
    },
    {
      country: 'TR',
      currency: 'TRY'
    },
    {
      country: 'TH',
      currency: 'THB'
    },
    {
      country: 'TW',
      currency: 'TWD'
    },
    {
      country: 'VN',
      currency: 'VND'
    },
    {
      country: 'ZA',
      currency: 'ZAR'
    }
  ],
  transakPaymentMethods: [
    {
      country: 'IN',
      methods: [
        {
          secondaryCountryFilter: ['IN'],
          method: 'neft_bank_transfer',
          name: 'IMPS',
          currency: 'INR'
        },
        {
          secondaryCountryFilter: ['IN'],
          method: 'upi',
          name: 'upi',
          currency: 'INR'
        }
      ]
    },
    {
      country: '',
      methods: [
        {
          secondaryCountryFilter: ['GB'],
          method: 'gbp_bank_transfer',
          name: 'gbp_bank_transfer',
          currency: 'GBP'
        },
        {
          secondaryCountryFilter: [
            'AT',
            'BE',
            'CY',
            'CZ',
            'EE',
            'FI',
            'FR',
            'DE',
            'GR',
            'IE',
            'IT',
            'LV',
            'LU',
            'MT',
            'RO',
            'NL',
            'PT',
            'SK',
            'SL',
            'ES',
            'BN'
          ],
          method: 'sepa_bank_transfer',
          name: 'sepa_bank_transfer',
          currency: 'EUR'
        }
      ]
    }
  ],
  countryList: [
    {
      id: 0,
      country: 'All Other Countries',
      countryCode: '',
      moonpay: true,
      moonpayMethods: ['credit_card', 'apple_pay', 'google_pay', 'samsung_pay'],
      xanpool: false,
      transak: true
    },
    {
      id: 1,
      country: 'Australia',
      countryCode: 'AU',
      moonpay: true,
      moonpayMethods: ['credit_card', 'apple_pay', 'google_pay', 'samsung_pay'],
      xanpool: false,
      transak: false
    },
    {
      id: 2,
      country: 'Brazil',
      countryCode: 'BR',
      moonpay: true,
      moonpayMethods: ['credit_card', 'apple_pay', 'google_pay', 'samsung_pay'],
      xanpool: false,
      transak: false
    },
    {
      id: 3,
      country: 'Canada',
      countryCode: 'CA',
      moonpay: true,
      moonpayMethods: ['credit_card', 'apple_pay', 'google_pay', 'samsung_pay'],
      xanpool: false,
      transak: false
    },
    {
      id: 4,
      country: 'Colombia',
      countryCode: 'CO',
      moonpay: true,
      moonpayMethods: ['credit_card', 'google_pay'],
      xanpool: false,
      transak: false
    },
    {
      id: 5,
      country: 'Hong Kong',
      countryCode: 'HK',
      moonpay: true,
      moonpayMethods: ['credit_card', 'apple_pay', 'google_pay', 'samsung_pay'],
      xanpool: true,
      transak: false
    },
    {
      id: 6,
      country: 'India',
      countryCode: 'IN',
      moonpay: true,
      moonpayMethods: ['google_pay', 'samsung_pay'],
      xanpool: false,
      transak: true
    },
    {
      id: 7,
      country: 'Indonesia',
      countryCode: 'ID',
      moonpay: true,
      moonpayMethods: ['credit_card', 'google_pay'],
      xanpool: true,
      transak: false
    },
    {
      id: 8,
      country: 'Israel',
      countryCode: 'IL',
      moonpay: true,
      moonpayMethods: ['credit_card', 'google_pay'],
      xanpool: true,
      transak: false
    },
    {
      id: 9,
      country: 'Malaysia',
      countryCode: 'MY',
      moonpay: true,
      moonpayMethods: ['credit_card', 'google_pay', 'samsung_pay'],
      xanpool: true,
      transak: false
    },
    {
      id: 10,
      country: 'Mexico',
      countryCode: 'MX',
      moonpay: true,
      moonpayMethods: ['credit_card', 'google_pay', 'samsung_pay'],
      xanpool: false,
      transak: false
    },
    {
      id: 11,
      country: 'New Zealand',
      countryCode: 'NZ',
      moonpay: true,
      moonpayMethods: ['credit_card', 'apple_pay', 'google_pay'],
      xanpool: false,
      transak: false
    },
    {
      id: 12,
      country: 'Nigeria',
      countryCode: 'NG',
      moonpay: true,
      moonpayMethods: ['credit_card', 'apple_pay', 'google_pay', 'samsung_pay'],
      xanpool: false,
      transak: false
    },
    {
      id: 13,
      country: 'Peru',
      countryCode: 'PE',
      moonpay: true,
      moonpayMethods: ['credit_card', 'google_pay'],
      xanpool: false,
      transak: false
    },
    {
      id: 14,
      country: 'Philippines',
      countryCode: 'PH',
      moonpay: true,
      moonpayMethods: ['credit_card', 'google_pay'],
      xanpool: true,
      transak: false
    },
    {
      id: 15,
      country: 'Russia',
      countryCode: 'RU',
      moonpay: true,
      moonpayMethods: ['credit_card', 'apple_pay', 'google_pay', 'samsung_pay'],
      xanpool: true,
      transak: false
    },
    {
      id: 16,
      country: 'Singapore',
      countryCode: 'SG',
      moonpay: true,
      moonpayMethods: ['credit_card', 'apple_pay', 'google_pay', 'samsung_pay'],
      xanpool: true,
      transak: false
    },
    {
      id: 17,
      country: 'South Africa',
      countryCode: 'ZA',
      moonpay: true,
      moonpayMethods: ['credit_card', 'google_pay', 'samsung_pay'],
      xanpool: false,
      transak: false
    },
    {
      id: 18,
      country: 'South Korea',
      countryCode: 'KR',
      moonpay: true,
      moonpayMethods: ['credit_card', 'samsung_pay'],
      xanpool: true,
      transak: false
    },
    {
      id: 19,
      country: 'Taiwan',
      countryCode: 'TW',
      moonpay: true,
      moonpayMethods: ['credit_card', 'apple_pay', 'google_pay'],
      xanpool: false,
      transak: false
    },
    {
      id: 20,
      country: 'Thailand',
      countryCode: 'TH',
      moonpay: true,
      moonpayMethods: ['credit_card', 'google_pay', 'samsung_pay'],
      xanpool: true,
      transak: false
    },
    {
      id: 21,
      country: 'Turkey',
      countryCode: 'TR',
      moonpay: true,
      moonpayMethods: ['credit_card', 'google_pay'],
      xanpool: false,
      transak: false
    },
    {
      id: 22,
      country: 'Vietnam',
      countryCode: 'VN',
      moonpay: true,
      moonpayMethods: ['credit_card', 'google_pay', 'samsung_pay'],
      xanpool: true,
      transak: false
    }
  ],
  selectedPaymentMethod: undefined
}

export const mutations: MutationTree<PaymentMethodsState> = {
  setSelectedPaymentMethod (state, payload) {
    state.selectedPaymentMethod = payload
  }
}

export const getters: PaymentMethodsGetter = {
  getCountries: state => state.countryList,
  getCountryCurrencies: state => state.countryCurrencies,
  getTransakPaymentMethods: state => state.transakPaymentMethods,

  // used by HomeGameBanner
  getPaymentMethods: state => userCountryCode =>
    state.countryList.filter(
      country => country.countryCode === userCountryCode
    ),
  getSelectedPaymentMethod: state => state.selectedPaymentMethod
}

export const paymentMethods: Module<PaymentMethodsState, RootState> = {
  state,
  getters,
  mutations,
  namespaced: true
}
